function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Brick } from "zengular";
import { modalify } from "zengular-ui";
import modalError from "../modules/birck-decorators/modal-error";
import twig from "./password-reset-request.twig";
import Alert from "./alert.brick";
import "./password-reset-request.scss";
import { Ajax } from "zengular-util";
import Endpoints from "../modules/constants/end-points";
import errorMessages from "../modules/constants/error-messages";
import Guard from "../modules/validation/guard";
import errors from "../modules/constants/errors";
import EmailValidator from "../modules/validation/validator/email-validator";
var PasswordReset = (_dec = modalify(), _dec2 = modalError(errorMessages), _dec3 = Brick.register('gmr-password-reset-modal', twig), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Brick) {
  _inherits(PasswordReset, _Brick);

  var _super = _createSuper(PasswordReset);

  function PasswordReset() {
    _classCallCheck(this, PasswordReset);

    return _super.apply(this, arguments);
  }

  _createClass(PasswordReset, [{
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$('form').listen('submit', function (event) {
        event.preventDefault();

        _this.passwordReset();
      });
      this.$$('ok').listen('click', function () {
        return _this.passwordReset();
      });
      this.$$('close').listen('click', function () {
        return _this.close();
      });
    }
  }, {
    key: "beforeRender",
    value: function beforeRender(args) {
      this.email = args.email;
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        email: this.email
      };
    }
  }, {
    key: "passwordReset",
    value: function passwordReset() {
      var _this2 = this;

      var data = {
        email: this.$$('email').node.value
      };
      var guard = new Guard();
      guard.create('email').add(new EmailValidator().setMessage(errors.EmailFormat));
      guard.test(data).catch(function (error) {
        return _this2.handleError(error);
      }).then(function () {
        return Ajax.json(Endpoints.auth.password.request(), data).getJson;
      }).then(function (xhr) {
        return _this2.handleXhr(xhr);
      }).then(function () {
        return _this2.close();
      }).then(function () {
        return _this2.okay();
      }).then(function () {
        return Alert.modalify({
          icon: "fal fa-user",
          title: "Rendben",
          content: "A további teendőidről e-mail-ben tájékoztatunk!"
        });
      }).catch(function () {});
    }
  }]);

  return PasswordReset;
}(Brick)) || _class) || _class) || _class);
export { PasswordReset as default };